import { type Modification, type ProductRestaurant } from '../../types';
import { checkIfGreenBaseIngredient } from '../modifications';
import { checkIfDressingIngredient } from './check-if-dressing-ingredient';
import { checkIfMixableDressingIngredient } from './check-if-mixable-dressing-ingredient';

/**
 * Check if the product can have mix dressings
 */
export function checkIfCanMixDressings(params: Params) {
  const { restaurant, isDelivery, activeModifications } = params;

  const isOutpost = restaurant?.isOutpost ?? false;
  const selectedDressing = activeModifications.filter(checkIfDressingIngredient); // prettier-ignore
  const hasMixableDressing = selectedDressing.some(checkIfMixableDressingIngredient); // prettier-ignore
  const hasGreenBase = activeModifications.some(checkIfGreenBaseIngredient);

  return (
    !isDelivery &&
    !isOutpost &&
    selectedDressing.length > 0 &&
    hasMixableDressing &&
    hasGreenBase
  );
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  restaurant: ProductRestaurant | undefined;
  isDelivery: boolean;
  activeModifications: Modification[];
};
